<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div class="px-0 px-sm-4 py-4">
        <v-card
          :loading="loading"
          class="rounded-0"
          color="grey lighten-3"
          flat
        >
          <v-row class="pa-2" no-gutters cols="12">
            <v-col class="pa-2" cols="12" md="8">
              <v-card
                v-if="info && Object.keys(info).length > 0"
                class="rounded-lg d-flex flex-column flex-sm-row align-center fill-height py-4 py-sm-0"
                flat
              >
                <!-- تصویر -->
                <div class="pa-2 mb-4 mb-sm-0 w-100 text-center" style="max-width: 165px;">
                  <v-img
                    :src="getImage"
                    class="mx-auto"
                    contain
                    max-width="165"
                  >
                    <template v-slot:placeholder>
                      <v-skeleton-loader
                        class="rounded"
                        max-width="100%"
                        type="card"
                      />
                    </template>
                  </v-img>
                </div>

                <!-- اطلاعات -->
                <div class="d-flex flex-column px-4 pb-4 pa-md-0 w-100">
                  <v-card-text class="pa-0 d-inline-block text-center text-sm-right">
                    <v-card-subtitle class="pa-0 ms-sm-10 mb-2">
                      {{ info.type | qrType("name") }}
                    </v-card-subtitle>
                    
                    <div class="font-size-h4 font-weight-bold d-flex flex-wrap justify-center justify-sm-start align-center">
                      <v-badge
                      v-if="$options.filters.qrType(info.type, 'pro')"
                      color="transparent"
                      overlap
                      offset-x="23"
                      offset-y="10"
                    >
                      <template #badge>
                        <v-icon color="grey darken-3" size="13" class="glow-crown">mdi-crown</v-icon>
                      </template>
                      <v-icon class="me-2 icon-list-type" color="grey darken-3" size="32">mdi-{{ info.type | qrType("icon") }}</v-icon>
                    </v-badge>
                    <v-icon v-else class="me-2 icon-list-type" color="grey darken-3" size="32">mdi-{{ info.type | qrType("icon") }}</v-icon>
                      <div
                        v-if="!editVisitName"
                        class="d-inline-flex align-center"
                        style="height: 40px"
                      >
                        {{ info.title }}
                        <v-btn icon small @click="editVisitName = true">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </div>
                      <v-card
                        v-else
                        v-click-outside="onCloseField"
                        class="d-inline-block mt-2 mt-sm-0"
                        flat
                        max-width="250"
                      >
                        <div class="rowinfo">
                          <v-text-field
                            v-model="editedName"
                            :disabled="nameLoading"
                            :error-messages="errorMessage"
                            :hide-details="!errorMessage"
                            :loading="nameLoading"
                            append-icon="check"
                            autofocus
                            clearable
                            class="contentinfo"
                            dense
                            outlined
                            @click:append="updateVisitName"
                            @click:clear="onCloseField"
                            @keydown.enter="updateVisitName"
                          />
                        </div>
                      </v-card>
                    </div>

                    <div class="pt-2 desc-text w-fit-content cursor-pointer mx-auto mx-sm-0 d-flex justify-center justify-sm-start align-center">
                      <v-icon class="ms-1 me-2" size="22">mdi-link-variant</v-icon>
                      <v-tooltip v-model="showTooltip" color="green darken-1" top>
                        <template v-slot:activator="{ on, attrs }">
                          <a
                            :href="isSpecialUser ? '' : qrLink"
                            :style="isSpecialUser ? 'user-select: none; pointer-events: none' : ''"
                            target="_blank"
                            v-on="on"
                            v-bind="attrs"
                            class="text-truncate d-inline-block"
                            style="max-width: 150px;"
                          >{{ displayLink }}</a>
                        </template>
                        <span>کپی شد</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            :disabled="isSpecialUser"
                            icon
                            small
                            v-bind="attrs"
                            @click="copyUrl"
                            v-on="on"
                            class="ms-2"
                          >
                            <v-icon small>mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                        <span>کپی</span>
                      </v-tooltip>
                    </div>

                    <v-tooltip left>
                      <template v-slot:activator="{ on, attr }">
                        <div
                          class="pt-2 desc-text w-fit-content mx-auto mx-sm-0 d-flex justify-center justify-sm-start align-center"
                          v-bind="attr"
                          v-on="on"
                        >
                          <v-icon class="ms-1 me-2" size="22">mdi-clock-outline</v-icon>
                          {{ dateDiffcreated }}
                        </div>
                      </template>
                      <span style="font-size: 0.8em">{{ tooltipdate }}</span>
                    </v-tooltip>
                  </v-card-text>
                </div>

                <v-spacer class="d-none d-sm-block" />
                
                <!-- بخش آمار و فیلترها -->
                <div class="fill-height d-flex flex-column w-100 mt-4 mt-sm-0">
                  <v-spacer class="d-none d-sm-block" />
                  <v-card-text class="text-center text-sm-left font-size-h6">
                    <span class="pa-2 grey--text">کل بازدید:</span>
                    <span class="green--text font-size-h1 font-weight-bolder">
                      {{ (staticClicks.all || 0) | persianNum }}
                    </span>
                    <br />
                    <span class="py-2 d-inline-block">
                      بازدید یکتا:
                      {{ (staticClicks.unique || 0) | persianNum }}
                    </span>
                  </v-card-text>
                  <v-spacer class="d-none d-sm-block" />

                  <v-card-actions class="justify-center justify-sm-end d-flex flex-wrap pa-2 gap-2">
                    <custom-date-picker
                      v-model="dateRange.startAt"
                      :max="computedMaxDate"
                      :min="!!info.created_at ? jalalian(info.created_at.split(' ')[0]) : ''"
                      input-class="start-date"
                      nullable
                      :key="$i18n.locale + '-start-date'"
                      format="date"
                    >
                      <template v-slot:default="{ inputClass }">
                        <v-btn :class="inputClass" class="ma-1" text small>
                          <span class="green--text ml-1">شروع: </span>
                          {{ !!dateRange.startAt ? datetime(dateRange.startAt) : "--" }}
                          <v-icon color="green" right small>mdi-calendar-range</v-icon>
                        </v-btn>
                      </template>
                    </custom-date-picker>

                    <v-btn
                      v-if="!!dateRange.startAt"
                      color="red"
                      icon
                      small
                      @click.stop="dateRange.startAt = ''"
                    >
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>

                    <custom-date-picker
                      v-model="dateRange.endAt"
                      :max="_maxDateCache"
                      :min="computedMinDate"
                      input-class="end-date"
                      nullable
                      :key="$i18n.locale + '-end-date'"
                      format="date"
                    >
                      <template v-slot:default="{ inputClass }">
                        <v-btn :class="inputClass" class="ma-1" text small>
                          <span class="green--text ml-1">پایان: </span>
                          {{ !!dateRange.endAt ? datetime(dateRange.endAt) : "--" }}
                          <v-icon color="green" right small>mdi-calendar-range</v-icon>
                        </v-btn>
                      </template>
                    </custom-date-picker>

                    <v-btn
                      v-if="!!dateRange.endAt"
                      color="red"
                      icon
                      small
                      @click.stop="dateRange.endAt = ''"
                    >
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>

                    <v-menu min-width="100" offset-y open-on-hover>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn text v-bind="attrs" v-on="on" small class="ma-1">
                          <span class="green--text ml-1">نمایش آمار:</span>
                          {{ selectedTypeText }}
                          <v-icon color="green" right small>mdi-selection-search</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item-group v-model="selectedType" color="primary" @change="handleTypeChange">
                          <v-list-item v-for="(item, index) in childTypes" :key="index" :value="item.value">
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>

                    <v-menu min-width="100" offset-y open-on-hover>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn text v-bind="attrs" v-on="on" small class="ma-1">
                          <span class="green--text ml-1">فیلتر:</span>
                          {{ computedFilterText }}
                          <v-icon color="green" right small>mdi-chart-areaspline</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item-group v-model="dateTypeModel" color="primary">
                          <v-list-item v-for="(item, index) in childFilters" :key="index" :value="item.value">
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                  </v-card-actions>
                </div>
              </v-card>

              <v-card v-else class="pa-4 d-flex align-center justify-center rounded-lg" flat height="100%">
                <v-skeleton-loader height="130" type="image" width="130" />
              </v-card>
            </v-col>

            <!-- بخش اکشن‌ها -->
            <v-col class="pa-2" cols="12" md="4">
              <v-card class="rounded-lg d-flex flex-column justify-space-between" flat height="100%" width="100%">
                <v-card-title class="align-end d-flex flex-wrap">
                  <div
                    v-if="!loading && !!getExpireAt"
                    :class="getExpireAt | untilExpire | expireColor"
                    class="expire-option mb-2 mb-sm-0"
                  >
                    <span class="bold-text">{{ renewBadgeText }}</span>
                  </div>
                  <v-spacer />
                  <v-tooltip v-if="!!info && !!Object.keys(info).length" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :href="findEditPage(info?.domain?.name, info?.identifier, info?.type, info?.qrId)"
                        class="rounded-lg"
                        color="black"
                        icon
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>ویرایش</span>
                  </v-tooltip>
                </v-card-title>

                <v-card-actions class="justify-center justify-sm-end flex-wrap gap-2 py-4">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        @click="goto(['qrLink','clickyarseo'].includes(info.type) ? `qr/design2/${!!info.qrId ? String(info.qrId) : ''}` : `qr/design/${info.domain.name}${!!info.identifier ? String(info.identifier) : ''}`)"
                        v-on="on"
                      >
                        <v-icon>mdi-palette</v-icon>
                      </v-btn>
                    </template>
                    <span>دیزاین</span>
                  </v-tooltip>

                  <v-tooltip v-if="info.status === 'active'" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" @click="showPause('deactivate')" v-on="on">
                        <v-icon>mdi-pause</v-icon>
                      </v-btn>
                    </template>
                    <span>متوقف کردن</span>
                  </v-tooltip>

                  <v-tooltip v-else top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" @click.stop="downloadQr" v-on="on">
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                    </template>
                    <span>دانلود</span>
                  </v-tooltip>

                  <v-tooltip color="red darken-1" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-hover v-slot="{ hover }">
                        <v-btn :color="hover ? 'red darken-2' : ''" icon v-bind="attrs" @click="showDestroy" v-on="on">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-hover>
                    </template>
                    <span>حذف</span>
                  </v-tooltip>
                </v-card-actions>

                <v-card-actions :class="getExpireAt | untilExpire | expireColor" class="download-wrapper pa-0">
                  <v-progress-circular
                    v-if="loading && !(info && Object.keys(info).length > 0)"
                    class="my-2 mx-auto"
                    color="white"
                    indeterminate
                    size="20"
                    width="3"
                  />
                  <v-btn
                    v-else-if="info.status === 'active'"
                    block
                    class="font-size-h6 rounded-b-lg rounded-t-0"
                    dark
                    large
                    text
                    @click.stop="downloadQr"
                  >
                    دانلود
                    <v-spacer />
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>

                  <v-btn
                    v-else
                    block
                    class="font-size-h6 rounded-b-lg rounded-t-0"
                    dark
                    large
                    outlined
                    @click="showPause('active')"
                  >
                    فعال کردن
                    <v-spacer />
                    <v-icon>mdi-reload</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-col class="pa-2" cols="12">
              <v-card class="rounded-lg pa-4 d-flex align-center flex-wrap" flat>
                <v-menu v-model="optionMenu" bottom nudge-bottom="5" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on">
                      <v-icon class="me-2">mdi-cog-outline</v-icon>
                      تنظیمات
                      <v-fade-transition mode="out-in">
                        <v-icon v-if="!optionMenu" key="down" class="ms-2">mdi-chevron-down</v-icon>
                        <v-icon v-else key="up" class="ms-2">mdi-chevron-up</v-icon>
                      </v-fade-transition>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item v-for="(item, i) in itemMenu" :key="i" :disabled="item.disabled" color="primary" @click="item.handler()">
                      <v-list-item-icon class="me-2">
                        <v-icon>mdi-{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>{{ item.text }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card>
            </v-col>

            <v-col class="pa-2" cols="12">
              <qr-statistics
                ref="statics"
                :filter="dateTypeModel"
                :range="dateRange"
                :selected-type="selectedType"
                @update:range="dateRange = $event"
                @update:filter="dateTypeModel = $event"
                @update:selected-type="selectedType = $event"
              />
            </v-col>
          </v-row>

          <custom-popup
            v-model="showDialog"
            :cons="cons"
            hide-confirm
            max-width="900"
            transition="dialog-bottom-transition"
          >
            <template v-slot:helpinfo>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-show-download-d`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="دانلود کیوآر"
              />
            </template>
            <v-card class="pa-5">
              <download-file-with-api
                v-if="showDialog"
                :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
                :svg="info.image"
                :visit-name="info.title"
                @close="showDialog = false"
                :qr_id="info?.qrId"
                :is-qrlink="['qrlink','clickyarseo'].includes(info?.type?.toLowerCase())"
              />
            </v-card>
          </custom-popup>
        </v-card>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import DownloadFileWithApi from "../qrland/downloadFileWithApi.vue";
import VisitCountChart from "./components/visitCountChart";
import OperationChart from "./components/operationChart";
import QrStatistics from "../QrStatistics";
import CustomDatePicker from "../../content/custom-date-picker";
import { AtomSpinner } from "epic-spinners";
import moment from "moment-jalaali";

export default {
  name: "statics",

  components: {
    CustomDatePicker,
    QrStatistics,
    OperationChart,
    VisitCountChart,
    DownloadFileWithApi,
    AtomSpinner,
  },

  data: () => ({
    menu: false,
    _maxDateCache: null,
    childFilters: [
      {
        index: 1,
        value: "d",
        text: "روزانه",
      },
      {
        index: 2,
        value: "w",
        text: "هفتگی",
      },
      {
        index: 3,
        value: "m",
        text: "ماهانه",
      },
      {
        index: 4,
        value: "y",
        text: "سالانه",
      },
    ],
    childTypes: [
      {
        value: "all",
        text: "همه",
      },
      {
        value: "unique",
        text: "یکتا",
      },
    ],
    debounceTimer: null,
    observerRetryCount: 0,
    isLoadingVisits: false,
    shouldLoadStatistics: false,
    helpData: [],
    serviceName: "Qrland",
    componentName: "statics",
    cons: { title: "دانلود کیوآر" },
    dateRange: {
      startAt: "",
      endAt: "",
    },
    dateTypeModel: "d",
    editVisitName: false,
    editedName: "",
    errorMessage: null,
    filterModel: "w",
    info: {},
    itemMenu: [],
    loading: false,
    nameLoading: false,
    optionMenu: false,
    selectedType: "all",
    showDialog: false,
    showTooltip: false,
    staticClicks: { all: 0, unique: 0 },
  }),

  mounted() {
    this._maxDateCache = moment().format(`jYYYY-jMM-jDD`);
    this.itemMenu = [
      {
        value: "download",
        text: "دانلود CSV",
        icon: "download",
        handler: null,
      },
      {
        value: "reset",
        text: "حذف آمار",
        icon: "reload",
        handler: this.resetStatics,
      },
    ];

    this.fetch();
    this.$nextTick(() => {
      this.setupStatisticsObserver();
    });
    this.setDefaultOneMonthRange();
  },

  computed: {
        getExpireAt() {
      return this.info.expire_at;
    },
  daysRemaining() {
      return this.getUntilExpire(this.getExpireAt);
    },

    renewBadgeText() {
      return this.getTypeText(this.daysRemaining, true);
    },
    
    renewButtonColor() {
      const colorClass = this.$options.filters.expireColor(this.daysRemaining);
      const colorMap = {
        "": "green darken-1",
        "in-month": "amber darken-2",
        "in-days": "amber darken-3",
        "in-expire": "red darken-2",
      };
      return colorMap[colorClass] || "red darken-2";
    },

    renewBadgeColor() {
      const colorClass = this.$options.filters.expireColor(this.daysRemaining);
      const colorMap = {
        "": "green darken-2",
        "in-month": "amber darken-3",
        "in-days": "orange lighten-1",
        "in-expire": "red darken-3",
      };},

    dateDiffcreated() {
      return this.dateDiffNow(this.info.created_at);
    },
    tooltipdate() {
      return this.dateString(this.info.created_at);
    },

    isSpecialUser() {
      return this.info?.user_id === 4;
    },
    qrLink() {
      let link = this.info.domain?.name || "";
      if (!link.startsWith("http")) {
        link = "https://" + link;
      }

      if (!!this.info.identifier) return link + this.info.identifier;
      return link;
    },
    displayLink() {
      let rgx = /^(http|https):\/\//gm;
      return this.qrLink.replace(rgx, "");
    },
    innerWidth() {
      return window.innerWidth;
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    getImage() {
      return `${this.info.img_url}`;
    },
    selectedTypeText() {
      if (!this.childTypes.length) return "";
      if (this.selectedType !== undefined) {
        const found = this.childTypes.find(
          (t) => t.value === this.selectedType,
        );
        return found ? found.text : "";
      }
      return "";
    },
    computedFilterText() {
      if (!this.childFilters.length) return "";
      const found = this.childFilters.find(
        (d) => d.value === this.dateTypeModel,
      );
      return found ? found.text : "";
    },
    computedMaxDate() {
      if (!!this.dateRange.endAt) {
        return this.jalalian(this.dateRange.endAt);
      }
      return this._maxDateCache;
    },
    computedMinDate() {
      if (this.dateRange.startAt) {
        return this.jalalian(this.dateRange.startAt);
      }
      return this.info.created_at
        ? this.jalalian(this.info.created_at.split(" ")[0])
        : "";
    },
  },
  watch: {
    showTooltip(val) {
      if (val) {
        setTimeout(() => {
          this.showTooltip = false;
        }, 2000);
      }
    },

    dateRange: {
      deep: false,
      handler(val, oldVal) {
        if (!oldVal) return;
        if (!oldVal || !val) {
          if (!this.isLoadingVisits) {
            this.debouncedGetVisits();
          }
          return;
        }
        const startChanged = val.startAt !== oldVal.startAt;
        const endChanged = val.endAt !== oldVal.endAt;
        if ((startChanged || endChanged) && !this.isLoadingVisits) {
          this.debouncedGetVisits();
        }
      },
    },
    selectedType: {
      handler(val, oldVal) {
        if (!oldVal) return;
        if (!oldVal || !val) {
          if (!this.isLoadingVisits) {
            this.debouncedGetVisits();
            // this.$forceUpdate();
          }
          return;
        }
      },
    },
    dateTypeModel: {
      handler(val, oldVal) {
        if (!oldVal) return;
        if (!oldVal || !val) {
          if (!this.isLoadingVisits) {
            this.debouncedGetVisits();
            // this.$forceUpdate();
          }
          return;
        }
      },
    },
  },

  onUnmounted() {
    if (observer) {
      observer.disconnect();
    }
  },
  methods: {
    dateString(input) {
      try {
        const locale = i18n.locale;
        moment.locale(locale === "fa" ? "fa" : locale === "ar" ? "ar" : "en");

        if (locale === "fa") {
          moment.loadPersian({ dialect: "persian-modern" });
        }

        const dateFormatPatterns = {
          fa: "dddd LL",
          ar: "dddd, LL",
          en: "dddd, MMMM D, YYYY",
        };

        const datePart = moment(input, "YYYY-M-D").format(
          dateFormatPatterns[locale] || dateFormatPatterns.en,
        );
        const timePart = moment(input, "YYYY-M-D HH:mm:ss").format("LT");

        return `${datePart} ${i18n.t("filters.dateString.at")} ${timePart}`;
      } catch (e) {
        return input;
      }
    },
    dateDiffNow(input) {
      try {
        let moment = require("moment-jalaali");
        moment.loadPersian({ dialect: "persian-modern" });
        return moment(input).fromNow();
      } catch (e) {
        return input;
      }
    },
    handleTypeChange(value) {
      this.selectedType = value;
      this.$forceUpdate();
    },
    nowDateString(sp = "/", type = "date") {
      if (this.$i18n.locale === "fa") {
        return type === "date"
          ? moment().format(`jYYYY${sp}jMM${sp}jDD`)
          : moment().format(`jYYYY${sp}jMM${sp}jDD HH:mm:ss`);
      } else {
        return type === "date"
          ? moment().format(`YYYY${sp}MM${sp}DD`)
          : moment().format(`YYYY${sp}MM${sp}DD HH:mm:ss`);
      }
    },

    setDefaultOneMonthRange() {
      const endDate = "";
      const startDate = "";
      if (!this.dateRange.startAt && !this.dateRange.endAt) {
        this.dateRange.startAt = startDate;
        this.dateRange.endAt = endDate;
      }

      this.$nextTick(() => {
        this.debouncedGetVisits();
      });
    },
    setupStatisticsObserver() {
      if (!this.observerRetryCount) {
        this.observerRetryCount = 0;
      }

      if (!window.IntersectionObserver) {
        this.observerRetryCount++;

        if (this.observerRetryCount >= 10) {
          setTimeout(() => {
            this.shouldLoadStatistics = true;
          }, 500);
          return;
        }

        setTimeout(() => {
          this.setupStatisticsObserver();
        }, 100);
        return;
      }

      // Reset counter
      this.observerRetryCount = 0;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.shouldLoadStatistics = true;
              observer.disconnect();
            }
          });
        },
        {
          rootMargin: "200px",
          threshold: 0.1,
        },
      );

      this.$nextTick(() => {
        const statsContainer = this.$el?.querySelector(".pa-2:last-child");
        if (statsContainer) {
          observer.observe(statsContainer);
        } else {
          // Fallback
          setTimeout(() => {
            this.shouldLoadStatistics = true;
          }, 1000);
        }
      });
    },

    fetch() {
      this.loading = true;

      const domain = `${this.domainName}/${this.qrId}`;
      this.$api
        .get(
          this.$route.fullPath.includes("qr/statistics2")
            ? `/v1/testQr/find1/${this.domainName}`
            : `/v1/testQr/find/${domain}`,
        )
        .then(({ data }) => {
          this.info = data.data;
          this.editedName = data.data.visitName;
          setTimeout(() => {
            if (!this.isLoadingVisits) {
              this.debouncedGetVisits();
            }
          }, 100);
        })
        .finally(() => (this.loading = false));
    },
    debouncedGetVisits() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.getVisits();
      }, 300); // 300ms delay
    },

    getVisits() {
      if (this.isLoadingVisits) return;
      this.isLoadingVisits = true;

      // this.$nextTick(() => {
      //   this.loading = true;
      // });

      let params = this.$route.fullPath.includes("qr/statistics2")
        ? {
            identifier: this.domainName || "",
          }
        : {
            domain: this.domainName + "/",
            identifier: this.qrId || "",
          };
      if (!!this.dateRange.startAt) params.start_at = this.dateRange.startAt;
      if (!!this.dateRange.endAt) params.end_at = this.dateRange.endAt;

      this.$api
        .get("/v1/testQr/statistics-click", {
          params: params,
        })
        .then(({ data }) => {
          this.$set(this.staticClicks, "all", data.data?.all ?? 0);
          this.$set(this.staticClicks, "unique", data.data?.unique ?? 0);
        })
        .catch(({ response }) => console.log("error in get clicks: ", response))
        .finally(() => {
          // this.$nextTick(() => {
          // this.loading = false;
          this.isLoadingVisits = false;
          // this.$forceUpdate();
          // });
        });
    },
    findEditPage(name, id, type, qrid) {
      qrid=qrid?.replace('?gateway=true','');
      const types = {
visitcard: `#/qr/edit/${name}${!!id ? id : ""}`,
        visitcardpro: `#/qr/editpro/${name}${!!id ? id : ""}`,
        business: `#/qr/editBpage/${name}${!!id ? id : ""}`,
        socialmedia: `#/qr/editSocial/${name}${!!id ? id : ""}`,
        commericial: `#/qr/editCpage/${name}${!!id ? id : ""}`,
        qrlist: `#/qr/qrlist/${!!id ? id : ""}`,
        goldlabel: `#/qr/goldlabel/${name}${!!id ? id : ""}`,
        labelproduct: `#/qr/labelproduct/${name}${!!id ? id : ""}`,
        voicegallery: `#/qr/editVoice/${name}${!!id ? id : ""}`,
        voicegallerypro: `#/qr/editVoicePro/${name}${!!id ? id : ""}`,
        consultationqr: `#/qr/consultationQrEdit/${name}${!!id ? id : ""}`,
        qrlink: `#/qr/link/${!!qrid ? qrid : ""}`,
        clickyarseo: `#/qr/linkpro/${!!qrid ? qrid : ""}`,
        videogallery: `#/qr/editVideo/${name}${!!id ? id : ""}`,
        photogallery: `#/qr/editPhoto/${name}${!!id ? id : ""}`,
        singleproduct: `#/qr/product/${name}${!!id ? id : ""}`,
        menu: `#/qr/editMenu/${name}${!!id ? id : ""}`,
        bshop: `#/qr/editBShop/${name}${!!id ? id : ""}`,
        application: `#/qr/editApplication/${name}${!!id ? id : ""}`,
        cshop: `#/qr/editCShop/${name}${!!id ? id : ""}`,
        appointment: `#/qr/editAppointment/${name}${!!id ? id : ""}`,
        insurance: `#/qr/insurance/${name}${!!id ? id : ""}`,
        wheel: `#/qr/luck-wheel/${name}${!!id ? id : ""}`,
        multicard: `#/qr/multicard/${name}${!!id ? id : ""}`,
        feedbackgallery: `#/qr/editFeedback/${name}${!!id ? id : ""}`,
        productpro: `#/qr/productPro/${name}${!!id ? id : ""}`,
        pdfgallery: `#/qr/editPdf/${name}${!!id ? id : ""}`,
        catalog: `#/qr/editcatalog/${name}${!!id ? id : ""}`,
        gift:`#/qr/editgift/${name}${!!id ? id : ""}`,
        text:`#/qr/editText/${name}${!!id ? id : ""}`,
        qrbale:`#/qr/editBale/${name}${!!id ? id : ""}`,
        qrrobika:`#/qr/editRobika/${name}${!!id ? id : ""}`,
        qreitaa:`#/qr/editEitaa/${name}${!!id ? id : ""}`,
        bankcard:`#/qr/bankcard/${name}${!!id ? id : ""}`,
        pricelabel: `#/qr/labelprice/${name}${!!id ? id : ""}`,
        attendanceqr: `#/qr/editattendance/${name}${!!id ? id : ""}`,     


      };

      return types[type.toLowerCase()];
    },

    async showPause(input) {
      let msg =
        input === "deactivate"
          ? "آیا از متوقف کردن کیوآر مطمئن هستید؟"
          : "آیا از فعال کردن کیوآر مطمئن هستید؟";
      if (await this.$modal.yesNo(msg)) {
        this.disable(input);
      }
    },
    disable(input) {
      this.loading = true;

      this.$api
        .put("/v1/testQr/update", {
          domain: this.domainName + "/",
          identifier: !!this.info.identifier ? this.qrId : "",
          status: input,
          qr_id: this.info.qrId,
        })
        .then(({ data }) => {
          this.fetch();
        })
        .catch(({ response }) => console.log("error in paused qr: ", response))
        .finally(() => (this.loading = false));
    },

    async showDestroy() {
      if (await this.$modal.yesNo("آیا از حذف کیوآر مطمئن هستید؟")) {
        this.destroy();
      }
    },
    destroy() {
      this.loading = true;

      this.$api
        .delete(`/v1/testQr/delete`, {
          params:
            !["qrLink",'clickyarseo'].includes(this.info.type)
              ? {
                  domain: this.info?.domain?.name,
                  identifier: this.info?.identifier || "",
                }
              : {
                  qr_id: this.info?.id,
                },
        })
        .then(({ data }) => {
          this.$toast.success("کیوآر با موفقیت حذف شد.");
          this.goto("qr/list");
        })
        .catch(({ response }) => console.log("error in delete qr: ", response))
        .finally(() => (this.loading = false));
    },

    copyUrl() {
      if (this.info.domain) {
        navigator.clipboard.writeText(this.qrLink);
        this.showTooltip = true;
      }else if(this.info?.dest_link){
        navigator.clipboard.writeText(this.info?.dest_link)
        this.showTooltip = true;
      }
    },
    onCloseField() {
      this.errorMessage = null;
      this.editVisitName = false;
    },
    updateVisitName() {
      if (!this.editedName || this.editedName.length <= 0) {
        this.errorMessage = "نام کارت ویزیت را به درستی وارد نمایید!";
        return;
      }

      this.nameLoading = true;
      this.$api
        .put("/v1/testQr/update", {
          qr_id: this.info.qrId,
          title: this.editedName,
          domain: this.domainName + "/",
          identifier: this.info.identifier,
        })
        .then(({ data }) => {
          this.onCloseField();
          this.info.title = this.editedName;
        })
        .finally(() => (this.loading = false));
    },
    downloadQr() {
      this.showDialog = true;
      // let src = this.info[this.info.format];
      // const data = JSON.stringify(src);
      // const link = document.createElement("a");
      // let type = this.info.format;
      // link.setAttribute(
      //   "href",
      //   "data:text/plain;charset=utf-8," + encodeURIComponent(data)
      // );
      // link.setAttribute(
      //   "download",
      //   this.info.visitName + `.${type}` || "data.json"
      // );
      // link.style.display = "none";
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
    },
    async resetStatics() {
      this.loading = true;

      if (
        await this.$modal.yesNo(
          "از حذف آمار اطمینان دارید ؟",
          "با حذف آمار، اطلاعات جداول ریست میشوند!",
        )
      ) {
        this.$api
          .post("/v1/testQr/reset-statistics", {
            domain: this.domainName + "/",
            identifier: !!this.info.identifier ? this.qrId : "",
          })
          .then(({ data }) => {
            this.$toast.success("با موفقیت حذف شد");
            this.fetch();
          })
          .catch(({ response }) => {
            if (response?.data?.message) {
              this.$toast.error(response.data.message);
            } else {
              console.log("error in reset statics: ", response);
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.expire-option {
  width: fit-content;
  white-space: nowrap;
  padding: 2px 8px;
  color: forestgreen;
}

.download-wrapper {
  background: linear-gradient(to right bottom, #02c182, #02c182, #08f1a1);
}

.expire-option.in-month {
  color: var(--v-warning-base);
}

.download-wrapper.in-month {
  background: var(--v-warning-base);
}

.expire-option.in-days {
  color: darkorange;
}

.download-wrapper.in-days {
  background: darkorange;
}

.expire-option.in-expire {
  color: var(--v-third-base);
}

.download-wrapper.in-expire {
  background: var(--v-third-base);
}

.desc-text,
.desc-text >>> a,
.desc-text >>> .v-icon:not(:hover) {
  color: #c2c2c2;
}

.chart-wrapper {
  /*background: linear-gradient(to right, #1D9191, #5FBCBC);*/
  background: linear-gradient(to right, #02c182, #08f1a1);
}
.apex-custom-label tspan,
.apex-custom-label title {
  font-family: "Vazir", serif !important;
}
</style>
